export function getReadableTextColor(hexOrColor) {
  const hex = typeof hexOrColor === 'string' ? hexOrColor : hexOrColor?.hex;
  if (!hex || typeof hex !== 'string') return '#111827'; // gray-900

  const normalized = hex.replace('#', '').trim();
  if (normalized.length !== 6) return '#111827';

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);

  // Relative luminance (sRGB)
  const srgb = [r, g, b].map(v => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });

  const luminance = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];

  // If background is light, use dark text; else white text
  return luminance > 0.6 ? '#111827' : '#ffffff';
}
